export default {
  name: 'A5',
  margin: '16px 0 8px'
}
